/* assets/mega-menu-tabs.js */
(function () {
  if (customElements.get('mega-menu-tabs')) return;

  class MegaMenuTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.tabs = Array.from(this.querySelectorAll('[data-mega-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-mega-panel]'));
      if (!this.tabs.length) return;

      this.tabs.forEach((tab, i) => {
        // Click switches the tab. Clicking the tab that is already open follows its link (if it has one).
        tab.addEventListener('click', (e) => {
          if (tab.getAttribute('aria-selected') !== 'true') {
            e.preventDefault();
            this.activate(i);
          }
        });

        tab.addEventListener('keydown', (e) => this.onKeydown(e, i));
      });

      this.panels.forEach((panel) => this.initSlider(panel));

      // Theme editor: selecting a tab block switches to it
      this.onBlockSelect = (e) => {
        const i = this.tabs.findIndex((t) => t.dataset.blockId === e.detail.blockId);
        if (i > -1) this.activate(i);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      if (this.observers) this.observers.forEach((o) => o.disconnect());
      this.observers = [];
      this.initialized = false;
    }

    activate(index) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (this.panels[i]) this.panels[i].hidden = !on;
      });
    }

    onKeydown(e, i) {
      const last = this.tabs.length - 1;
      let next = null;

      if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
      else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = last;

      if (next === null) return;
      e.preventDefault();
      this.activate(next);
      this.tabs[next].focus();
    }

    initSlider(panel) {
      const track = panel.querySelector('[data-mega-track]');
      const controls = panel.querySelector('[data-mega-controls]');
      const prev = panel.querySelector('[data-mega-prev]');
      const next = panel.querySelector('[data-mega-next]');
      if (!track || !controls || !prev || !next) return;

      // Never use the "disabled" attribute here: when a focused button becomes disabled the browser
      // drops focus, Broadcast's hover-disclosure sees a focusout and closes the dropdown.
      const setDisabled = (btn, off) => {
        btn.setAttribute('aria-disabled', off ? 'true' : 'false');
      };

      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = max <= 2;
        setDisabled(prev, track.scrollLeft <= 2);
        setDisabled(next, track.scrollLeft >= max - 2);
      };

      const scrollByPage = (dir) => {
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        const perPage = Math.max(1, Math.floor(track.clientWidth / step));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: dir * step * perPage, behavior: reduce ? 'auto' : 'smooth' });
      };

      [prev, next].forEach((btn) => {
        // Mouse clicks don't move focus, so nothing inside the dropdown loses focus
        btn.addEventListener('mousedown', (e) => e.preventDefault());
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (btn.getAttribute('aria-disabled') === 'true') return;
          scrollByPage(btn === prev ? -1 : 1);
        });
      });

      track.addEventListener('scroll', update, { passive: true });

      // Panel is display:none until its tab / the dropdown opens, so measure again when it gets a size
      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(update);
        ro.observe(track);
        this.observers = this.observers || [];
        this.observers.push(ro);
      } else {
        window.addEventListener('resize', update);
      }

      update();
    }
  }

  customElements.define('mega-menu-tabs', MegaMenuTabs);
})();